import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useState, } from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import ErrorLabel from './labels/ErrorLabel';
import styled from 'styled-components';
const DropzoneWrapper = styled.div `
    min-width: 400px;
`;
const Layout = ({ input, previews, submitButton, dropzoneProps, files, extra: { maxFiles }, }) => {
    return (_jsxs("div", { children: [previews, _jsx("div", { ...dropzoneProps, children: files.length < maxFiles && input }), files.length > 0 && submitButton] }));
};
const FileUploader = forwardRef(({ data, errors, setData, isDisabled = false }, ref) => {
    // keep track of files from dropzone to later be able to remove them
    // for resetting from parent form. Note that this state is not used
    // in presentation.
    const [filesState, setFilesState] = useState([]);
    const handleChangeStatus = (file, status, files) => {
        if (['done'].includes(status)) {
            setFilesState([...filesState, file]);
        }
        if (['removed'].includes(status)) {
            setFilesState([...filesState].filter(fileStateFile => fileStateFile !== file));
        }
        if (['done', 'removed'].includes(status)) {
            setData('dossier_files', files
                .filter(fileWithMeta => !(fileWithMeta.file === file.file &&
                status === 'removed'))
                .map(fileWithMeta => fileWithMeta.file));
        }
    };
    let fileErrors = [];
    data.dossier_files?.map((_file, index) => {
        const error = errors?.[`dossier_files.${index}`];
        if (error) {
            fileErrors.push(error);
        }
    });
    const reset = () => filesState.forEach(f => {
        try {
            f.remove();
        }
        catch (e) { }
    });
    useImperativeHandle(ref, () => ({ reset }));
    return (_jsxs(DropzoneWrapper, { children: [errors?.dossier_files && (_jsx(ErrorLabel, { children: errors.dossier_files })), fileErrors.map(message => (_jsx(ErrorLabel, { children: message }))), _jsx(Dropzone, { LayoutComponent: Layout, inputContent: "Sleep / upload hier uw documenten", inputWithFilesContent: "Sleep / upload nog een document", maxSizeBytes: 10_000_000, disabled: isDisabled, onChangeStatus: handleChangeStatus, submitButtonDisabled: true, canRemove: true })] }));
});
export default FileUploader;
